<script setup lang="ts">
  import { EditorPageHeader } from '@/shared/ui/components'

  import { NewsEditor } from '@/features/news'

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('news_create_page_title'),
  })
</script>

<template>
  <div class="wide-responsive flex w-full flex-col">
    <EditorPageHeader
      parent-route-name="/news/[[page]]"
      parent-label-key="navigation_item_news"
      :current-label="$t('news_breadcrumb_add')"
      data-testid="news-editor-page-header"
    />
    <NewsEditor mode="create" />
  </div>
</template>
